import { render, staticRenderFns } from "./ExhibitionContent.vue?vue&type=template&id=72d25f6c&scoped=true&"
import script from "./ExhibitionContent.vue?vue&type=script&lang=js&"
export * from "./ExhibitionContent.vue?vue&type=script&lang=js&"
import style0 from "./ExhibitionContent.vue?vue&type=style&index=0&id=72d25f6c&scoped=true&lang=css&"
import style1 from "./ExhibitionContent.vue?vue&type=style&index=1&lang=css&"
import style2 from "assets/css/ckeditor.css?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d25f6c",
  null
  
)

export default component.exports